import React, { useContext, useEffect } from "react";

import SettingsSection from "../components/section/SettingsSection";
import PageTitle from "../components/pageTitle/PageTitle";
import ContactForm from "../components/contact/ContactForm";
import { ContactFormValues } from "../components/contact/types";
import { fetchPostJSON } from "../utils/api-helpers";
import { ModalContext } from "../context/ModalContext";
import ContactCompleteModal from "../components/modal/contactCompleteModal/contactCompleteModal";

const Contact = (): JSX.Element => {
  const { handleModal } = useContext(ModalContext);

  // TODO - update this function to send email to OR
  const handleContactForm = async (data: ContactFormValues) => {
    const formData = new FormData();

    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    await fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      //@ts-ignore
      body: new URLSearchParams(formData).toString(),
    });

    handleModal({
      content: <ContactCompleteModal />,
      withImage: true,
    });
  };

  return (
    <SettingsSection>
      <PageTitle title="Contact us" />

      <ContactForm handleContactForm={handleContactForm} />
    </SettingsSection>
  );
};

export const getStaticProps = async ({ params }) => {
  // const client = createClient();

  // const page = await client.getSingle("home");

  return {
    props: {},
  };
};

export default Contact;
